import { forgotPasswordApiRequest, resetPasswordApiReqeust, signUpApiRequest } from '@guryou/api-client';
import { loginApiRequest, updateUserLoginApiCall } from '@guryou/api-client-gql';
import { Auth } from 'aws-amplify';
import camelcaseKeys from 'camelcase-keys';
import { resetState } from './resetActions';
import { ActionStatus, buildActionType, NotificationType, SuccessNotification } from '../core';
import { FORGOT_PASSWORD, LOGIN, LOGOUT, NOTIFICATION, RESET_PASSWORD, SIGN_UP, STORAGE_PERSIST, TOKEN_PROVIDER } from '../types';
const handleLoginFromCookie = data => dispatch => {
  const {
    accessToken,
    refreshToken,
    ...user
  } = camelcaseKeys(data);
  dispatch({
    type: buildActionType(LOGIN, ActionStatus.DONE),
    payload: {
      accessToken,
      refreshToken,
      user
    }
  });
};
const passwordLoginAction = function (email, password, persistor) {
  let appName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'guryou';
  let appVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : process.env.REACT_APP_VERSION;
  let appOs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : process.env.REACT_APP_APP_OS;
  return async dispatch => {
    dispatch({
      type: buildActionType(LOGIN, ActionStatus.START)
    });
    const response = await loginApiRequest(email, password, appName, appVersion, appOs);
    if (response.success) {
      const {
        accessToken,
        refreshToken,
        ...user
      } = response;
      dispatch({
        type: buildActionType(LOGIN, ActionStatus.DONE),
        payload: {
          accessToken,
          refreshToken,
          user
        }
      });
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: "".concat(SuccessNotification[LOGIN.action], " logged in"),
          variant: NotificationType.Success
        }
      });
      if (persistor) {
        await persistor.flush();
      }
      dispatch({
        type: buildActionType(STORAGE_PERSIST, ActionStatus.DONE)
      });
    } else {
      dispatch({
        type: buildActionType(LOGIN, ActionStatus.FAILED),
        payload: response
      });
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: 'Please enter a valid Email and Password.',
          variant: NotificationType.Error
        }
      });
    }
  };
};
export const updateUserLogin = (userId, providerId, persistor) => async dispatch => {
  dispatch({
    type: buildActionType(LOGIN, ActionStatus.REFRESH)
  });
  const responseData = await updateUserLoginApiCall({
    userId,
    providerId
  });
  if (responseData) {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, async (err, session) => {
      if (err) {
        dispatch({
          type: buildActionType(LOGIN, ActionStatus.FAILED),
          payload: err
        });
      }
      const {
        idToken: {
          payload,
          jwtToken
        }
      } = session;
      dispatch({
        type: buildActionType(LOGIN, ActionStatus.DONE),
        payload: {
          ...payload,
          jwtToken
        }
      });
      if (persistor) {
        await persistor.flush();
      }
      dispatch({
        type: buildActionType(STORAGE_PERSIST, ActionStatus.DONE)
      });
    });
  } else {
    dispatch({
      type: buildActionType(LOGIN, ActionStatus.FAILED),
      payload: 'Something went wrong'
    });
  }
};
export const updateUserLoginMobile = (userId, providerId) => async dispatch => {
  dispatch({
    type: buildActionType(TOKEN_PROVIDER, ActionStatus.START)
  });
  const responseData = await updateUserLoginApiCall({
    userId,
    providerId
  });
  if (responseData) {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, async (err, session) => {
      if (err) {
        dispatch({
          type: buildActionType(LOGIN, ActionStatus.FAILED),
          payload: err
        });
      }
      const {
        idToken: {
          payload,
          jwtToken
        }
      } = session;
      dispatch({
        type: buildActionType(TOKEN_PROVIDER, ActionStatus.DONE),
        payload: {
          ...payload,
          jwtToken
        }
      });
    });
  } else {
    dispatch({
      type: buildActionType(TOKEN_PROVIDER, ActionStatus.FAILED),
      payload: 'Something went wrong'
    });
  }
};
const forgotPassword = data => async dispatch => {
  dispatch({
    type: buildActionType(FORGOT_PASSWORD, ActionStatus.START)
  });
  const response = await forgotPasswordApiRequest(data);
  if (response.success) {
    dispatch({
      type: buildActionType(FORGOT_PASSWORD, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(FORGOT_PASSWORD, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'Please enter a valid email.',
        variant: NotificationType.Error
      }
    });
  }
};
const resetPassword = data => async dispatch => {
  dispatch({
    type: buildActionType(RESET_PASSWORD, ActionStatus.START)
  });
  const response = await resetPasswordApiReqeust(data);
  if (response.success) {
    dispatch({
      type: buildActionType(RESET_PASSWORD, ActionStatus.DONE),
      payload: response.data
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: "".concat(SuccessNotification._UPDATE),
        variant: NotificationType.Success
      }
    });
  } else {
    dispatch({
      type: buildActionType(RESET_PASSWORD, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'Invalid email or expired code',
        variant: NotificationType.Error
      }
    });
  }
};
const logoutAction = () => async dispatch => dispatch({
  type: LOGOUT
});
const signUp = (email, password, newsletter, marketing) => async dispatch => {
  dispatch({
    type: buildActionType(SIGN_UP, ActionStatus.START)
  });
  const response = await signUpApiRequest(email, password, newsletter, marketing);
  if (response.success) {
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: "".concat(SuccessNotification[LOGIN.action], " logged in"),
        variant: NotificationType.Success
      }
    });
  } else {
    dispatch({
      type: buildActionType(SIGN_UP, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'Successfully signed up',
        variant: NotificationType.Error
      }
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'Please check your e-mail',
        variant: NotificationType.Default
      }
    });
  }
};
const resetUserLoginState = () => async dispatch => dispatch(resetState(TOKEN_PROVIDER));
export { logoutAction, handleLoginFromCookie, passwordLoginAction, forgotPassword, resetPassword, signUp, resetUserLoginState };